import type { SVGProps } from "react";

export default function WordIcon(props: Readonly<SVGProps<SVGSVGElement>>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 20 20"
      fill="none"
      {...props}
    >
      <path
        d="M18.0036 1.875H6.06545C5.96761 1.87492 5.87072 1.89411 5.7803 1.93147C5.68988 1.96884 5.60771 2.02364 5.53847 2.09276C5.46923 2.16189 5.41429 2.24397 5.37677 2.33432C5.33926 2.42468 5.31991 2.52154 5.31982 2.61938V5.9375L12.2379 7.96875L18.7498 5.9375V2.61938C18.7497 2.52149 18.7304 2.42458 18.6928 2.33418C18.6553 2.24378 18.6003 2.16167 18.531 2.09254C18.4617 2.02341 18.3794 1.96862 18.2889 1.93129C18.1984 1.89396 18.1015 1.87484 18.0036 1.875Z"
        fill="#41A5EE"
      />
      <path
        d="M18.7498 5.9375H5.31982V10L12.2379 11.2188L18.7498 10V5.9375Z"
        fill="#2B7CD3"
      />
      <path
        d="M5.31982 10V14.0625L11.8311 14.875L18.7498 14.0625V10H5.31982Z"
        fill="#185ABD"
      />
      <path
        d="M6.06545 18.125H18.0029C18.1009 18.1252 18.1979 18.1062 18.2885 18.0689C18.379 18.0316 18.4614 17.9768 18.5307 17.9077C18.6001 17.8385 18.6552 17.7564 18.6928 17.666C18.7303 17.5755 18.7497 17.4786 18.7498 17.3806V14.0625H5.31982V17.3806C5.31991 17.4785 5.33926 17.5753 5.37677 17.6657C5.41429 17.756 5.46923 17.8381 5.53847 17.9072C5.60771 17.9764 5.68988 18.0312 5.7803 18.0685C5.87072 18.1059 5.96761 18.1251 6.06545 18.125Z"
        fill="#103F91"
      />
      <path
        opacity="0.1"
        d="M10.2711 5.125H5.31982V15.2812H10.2711C10.4684 15.2803 10.6573 15.2016 10.797 15.0623C10.9367 14.9229 11.0158 14.7342 11.0173 14.5369V5.86937C11.0158 5.67209 10.9367 5.48333 10.797 5.34399C10.6573 5.20466 10.4684 5.12598 10.2711 5.125Z"
        fill="black"
      />
      <path
        opacity="0.2"
        d="M9.8642 5.53125H5.31982V15.6875H9.8642C10.0615 15.6865 10.2505 15.6078 10.3901 15.4685C10.5298 15.3292 10.609 15.1404 10.6104 14.9431V6.27562C10.609 6.07834 10.5298 5.88958 10.3901 5.75024C10.2505 5.61091 10.0615 5.53223 9.8642 5.53125Z"
        fill="black"
      />
      <path
        opacity="0.2"
        d="M9.8642 5.53125H5.31982V14.875H9.8642C10.0615 14.874 10.2505 14.7953 10.3901 14.656C10.5298 14.5167 10.609 14.3279 10.6104 14.1306V6.27562C10.609 6.07834 10.5298 5.88958 10.3901 5.75024C10.2505 5.61091 10.0615 5.53223 9.8642 5.53125Z"
        fill="black"
      />
      <path
        opacity="0.2"
        d="M9.45732 5.53125H5.31982V14.875H9.45732C9.65462 14.874 9.84358 14.7953 9.98326 14.656C10.1229 14.5167 10.2021 14.3279 10.2036 14.1306V6.27562C10.2021 6.07834 10.1229 5.88958 9.98326 5.75024C9.84358 5.61091 9.65462 5.53223 9.45732 5.53125Z"
        fill="black"
      />
      <path
        d="M1.99625 5.53125H9.4575C9.65514 5.53109 9.84477 5.6094 9.9847 5.74898C10.1246 5.88856 10.2034 6.07798 10.2038 6.27563V13.7244C10.2034 13.922 10.1246 14.1114 9.9847 14.251C9.84477 14.3906 9.65514 14.4689 9.4575 14.4688H1.99625C1.89836 14.4689 1.8014 14.4498 1.71091 14.4125C1.62042 14.3751 1.53817 14.3203 1.46887 14.2512C1.39956 14.1821 1.34456 14.1 1.30701 14.0096C1.26945 13.9192 1.25008 13.8223 1.25 13.7244V6.27563C1.25008 6.17774 1.26945 6.08083 1.30701 5.99043C1.34456 5.90003 1.39956 5.81792 1.46887 5.74879C1.53817 5.67966 1.62042 5.62487 1.71091 5.58754C1.8014 5.55021 1.89836 5.53109 1.99625 5.53125Z"
        fill="url(#paint0_linear_5937_191170)"
      />
      <path
        d="M4.3124 11.2425C4.32678 11.3575 4.33678 11.4575 4.34115 11.5431H4.35865C4.3649 11.4618 4.37865 11.3637 4.39928 11.2493C4.4199 11.135 4.43803 11.0381 4.4549 10.9587L5.23928 7.57933H6.25428L7.06678 10.9081C7.1141 11.114 7.14792 11.3228 7.16803 11.5331H7.18178C7.19671 11.3283 7.22489 11.1248 7.26615 10.9237L7.91553 7.57495H8.83865L7.69865 12.4175H6.61928L5.84615 9.2137C5.82365 9.1212 5.79824 9.00078 5.7699 8.85245C5.74157 8.70412 5.72407 8.59578 5.7174 8.52745H5.70428C5.69553 8.6062 5.67803 8.72308 5.65178 8.87808C5.62553 9.0337 5.6049 9.14808 5.58928 9.22308L4.8624 12.4193H3.7649L2.61865 7.57933H3.55615L4.26303 10.9656C4.28412 11.057 4.3006 11.1494 4.3124 11.2425Z"
        fill="white"
      />
      <defs>
        <linearGradient
          id="paint0_linear_5937_191170"
          x1="2.80875"
          y1="4.94625"
          x2="8.645"
          y2="15.0538"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#2368C4" />
          <stop offset="0.5" stopColor="#1A5DBE" />
          <stop offset="1" stopColor="#1146AC" />
        </linearGradient>
      </defs>
    </svg>
  );
}
